import { SwitchProps } from "@mui/material"
import { useContext } from "react"
import ModeSwitch from "src/shared/components/mode-switch"
import { ThemeContext } from "src/shared/context/theme-context"

const ThemeSwitch = ({ ...rest }: SwitchProps) => {
  const themeContext = useContext(ThemeContext)
  return <ModeSwitch {...rest} checked={themeContext?.mode === "dark"} onChange={() => themeContext?.toggleTheme()} />
}

export default ThemeSwitch
